export default class EnvLocal {
    // static REACT_APP_API_URL: string = 'https://hallapp-698953635440.herokuapp.com/'
    // static REACT_APP_API_URL: string = 'http://localhost:8080/'
     static REACT_APP_API_URL: string = 'https://api.hallapp.com.br/'
}